import { KeyValue } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';
import { ExpandedTable, TableTitle } from '../models';

@Component({
    selector: 'app-stat-table',
    templateUrl: './stat-table.component.html',
    styleUrls: ['./stat-table.component.scss'],
    standalone: false
})
export class StatTableComponent implements OnInit {
  @Input() dataArray: any[] = [];
  @Input() titleArray: string[] = [];
  @Input() titleGroups: TableTitle[] = [];
  @Input() expandable = false;
  @Input() expandedTables: ExpandedTable[][] = [];
  @Input() titleBackground = '#646A8C';
  @Input() stripeColor = '#C3C6D5';
  @Input() contrast = '#ffffff';
  @Input() useSummaryRow = false;
  @Input() summaryRowData: any = {};

  expanded = false;
  expandedIndexes: number[] = [];
  lighterShade = '#ddd';

  ngOnInit(): void {
    if (this.expandable) {
      document.documentElement.style.setProperty('--cursor', 'pointer');
    } else {
      document.documentElement.style.setProperty('--cursor', 'default');
    }
    document.documentElement.style.setProperty('--contrast', this.contrast);
    document.documentElement.style.setProperty('--darkest', this.titleBackground);
    document.documentElement.style.setProperty('--stripes', this.stripeColor);
    document.documentElement.style.setProperty(
      '--innerbg',
      this.colorShade(this.stripeColor, -10)
    );
  }

  originalOrder = (
    a: KeyValue<number, string>,
    b: KeyValue<number, string>
  ): number => {
    return 0;
  };

  colorShade(col: string, amt: number): string {
    col = col.replace(/^#/, '');
    if (col.length === 3) {
      col = col[0] + col[0] + col[1] + col[1] + col[2] + col[2];
    }
    let [r, g, b] = col.match(/.{2}/g) as RegExpMatchArray;
    let rNum = parseInt(r, 16) + amt;
    let gNum = parseInt(g, 16) + amt;
    let bNum = parseInt(b, 16) + amt;
    r = Math.max(Math.min(255, rNum), 0).toString(16);
    g = Math.max(Math.min(255, gNum), 0).toString(16);
    b = Math.max(Math.min(255, bNum), 0).toString(16);
    const rr = (r.length < 2 ? '0' : '') + r;
    const gg = (g.length < 2 ? '0' : '') + g;
    const bb = (b.length < 2 ? '0' : '') + b;
    return `#${rr}${gg}${bb}`;
  }

  expand(index: number): void {
    if (this.expandable) {
      if (!this.expandedIndexes.includes(index)) {
        this.expandedIndexes.push(index);
      } else {
        this.expandedIndexes.splice(this.expandedIndexes.indexOf(index), 1);
      }
    }
  }
}
